module.exports = __webpack_public_path__ + "static/media/logo.79469e4c.png";